import { render, staticRenderFns } from "./SocietyForm.vue?vue&type=template&id=78566e91&scoped=true"
import script from "./SocietyForm.vue?vue&type=script&lang=js"
export * from "./SocietyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78566e91",
  null
  
)

export default component.exports